import { useState, useCallback } from "react";
import Hero from "../components/Hero";
import StatsStrip from "../components/StatsStrip";
import ClientLogos from "../components/ClientLogos";
import WorldMap from "../components/WorldMap";
import FlagshipProjects from "../components/FlagshipProjects";
import HomeServicesTeaser from "../components/HomeServicesTeaser";
import CareerTeaser from "../components/CareerTeaser";
import Certifications from "../components/Certifications";
import Testimonials from "../components/Testimonials";
import ProjectDrawer from "../components/ProjectDrawer";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Home() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeCountry, setActiveCountry] = useState(null);
  const [focusedProject, setFocusedProject] = useState(null);

  const openDrawer = useCallback((iso, projectId = null) => {
    setActiveCountry(iso);
    setFocusedProject(projectId);
    setDrawerOpen(true);
  }, []);

  return (
    <>
      <Hero />
      <StatsStrip />
      <ClientLogos />

      {/* Services BEFORE Projects — visitors first learn what you do, then see proof */}
      <HomeServicesTeaser />

      <section data-testid="map-section" className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
            <div>
              <div className="overline">Project Atlas</div>
              <h2 className="font-serif text-4xl md:text-5xl mt-3" style={{ color: "var(--primary)" }}>
                Fifteen countries. One mission.
              </h2>
              <p className="mt-3 max-w-xl text-sm md:text-base" style={{ color: "var(--text-secondary)" }}>
                Click any highlighted country to explore the projects delivered there.
              </p>
            </div>
            <Link
              to="/projects"
              className="text-sm inline-flex items-center gap-1 link-underline font-semibold"
              data-testid="map-section-all-projects"
              style={{ color: "var(--primary)" }}
            >
              See all projects <ArrowRight size={14} />
            </Link>
          </div>

          <WorldMap onSelectCountry={(iso) => openDrawer(iso)} />
        </div>
      </section>

      <FlagshipProjects onOpen={openDrawer} />
      <CareerTeaser />
      <Certifications />
      <Testimonials />

      <section className="py-24 md:py-28 grain-overlay relative" style={{ backgroundColor: "var(--primary)", color: "var(--bg)" }} data-testid="home-cta">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-10 items-end relative z-10">
          <h2 className="font-serif text-4xl md:text-6xl leading-tight">
            Have a decarbonization problem worth solving?
          </h2>
          <div className="md:text-right">
            <Link
              to="/contact"
              data-testid="home-cta-button"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm"
              style={{ backgroundColor: "var(--accent)", color: "var(--primary)" }}
            >
              Start a conversation <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      <ProjectDrawer
        countryIso={activeCountry}
        open={drawerOpen}
        onOpenChange={setDrawerOpen}
        focusedProjectId={focusedProject}
      />
    </>
  );
}
